// extracted by mini-css-extract-plugin
export default {"inputPhone":"PhoneNumberInput_inputPhone__SGGnT","select":"PhoneNumberInput_select__Dl9II","flag":"PhoneNumberInput_flag__YM0S2","options":"PhoneNumberInput_options__w8Sg9"};